import {
  CardBody,
  Form,
  FormGroup,
  Input,
  Label,
  TabContent,
  TabPane,
} from "reactstrap";
import { borderData } from "../../Data/UiKitsData/TabsData";
import { TabDatatype } from "../../Types/UiKitsType";
import { H4, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Utils";
import UserProfiles from "../Apps/Users/UserProfiles";
import AttendanceMe from "../Dashboards/Attendance/AttendanceMe";
import ReportingStruct from "../Dashboards/Attendance/ReportingStruct";
import Inputss from "../Dashboards/Attendance/Inputs";
import Leaves from "../Dashboards/Attendance/Leaves";

export default function BorderTabContent({
  tabId,
  employeeIdProp,
  tdate,
  positionId,
}: {
  tabId: string;
  employeeIdProp?: number;
  tdate?: string;
  positionId?: number;
}) {
  const borderData: TabDatatype[] = [
    {
      id: "1",
      text: <UserProfiles employeeIdProp={employeeIdProp ?? 1} />,
    },
    {
      id: "2",
      text: employeeIdProp ? (
        <CardBody className="pb-0">
          <div className="main-inbox">
            <AttendanceMe
              employeeIdProp={employeeIdProp}
              tdate={tdate}
              positionId={positionId}
            />
          </div>
        </CardBody>
      ) : (
        <CardBody>
          <p>No employee data available</p>
        </CardBody>
      ),
    },
    {
      id: "3",
      text: (
        <CardBody className="px-0 pb-0">
          <ReportingStruct employee_id={employeeIdProp ?? 0} />
        </CardBody>
      ),
    },
    {
      id: "4",
      text: (
        <CardBody className="px-0 pb-0">
          <Inputss employeeIdProp={employeeIdProp ?? 0} />
        </CardBody>
      ),
    },
    {
      id: "5",
      text: (
        <CardBody className="px-0 pb-0">
          <Leaves employeeIdProp={employeeIdProp ?? 0}/>
        </CardBody>
      ),
    },
  ];
  return (
    <TabContent activeTab={tabId}>
      {borderData &&
        borderData.map((item, index) => (
          <TabPane
            className={`fade ${tabId === item.id ? "show" : ""}`}
            tabId={item.id}
            key={index}
          >
            {item.text}
          </TabPane>
        ))}
    </TabContent>
  );
}
